import { isPlatformBrowser } from '@angular/common';
import { Component, inject, input, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { Lang, LANGUAGES } from '../../../app.routes-config';
import { AnalyticsService } from '../../../services/analytics.service';
import { LanguageService } from '../../../services/language.service';
import { setStorageItem } from '../../../utils/storage';
import { Dropdown } from '../dropdown/dropdown';
import { Icon } from '../icon/icon';

@Component({
  imports: [TranslatePipe, Icon, Dropdown],
  selector: 'app-language-switcher',
  standalone: true,
  styleUrl: './language-switcher.scss',
  templateUrl: './language-switcher.html',
})
export class LanguageSwitcher {
  readonly native = input(false);

  get currentLang(): string | null {
    return this.translate.currentLang();
  }

  protected readonly languages: readonly Lang[] = LANGUAGES;
  private analytics = inject(AnalyticsService);
  private language = inject(LanguageService);
  private platformId = inject(PLATFORM_ID);
  private router = inject(Router);

  private translate = inject(TranslateService);

  onNativeChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    this.setLang(select.value as Lang);
  }

  setLang(lang: Lang): void {
    if (lang === this.language.current()) return;

    const target = this.language.switchUrl(this.router.url, lang);
    this.analytics.trackEvent('language_change', { language: lang });
    if (isPlatformBrowser(this.platformId)) setStorageItem('lang', lang);

    this.translate.use(lang);
    void this.router.navigateByUrl(target);
  }
}
